import React from 'react'

import Svg from './svg'


export default function GrabberIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-off') || color

    return <Svg width={width || '24px'} height={height || '48px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="grabber" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <circle id="Oval" fill={color} cx="34" cy="50" r="14"></circle>
            <circle id="Oval-Copy" fill={color} cx="66" cy="50" r="14"></circle>
            <circle id="Oval" fill={color} cx="34" cy="82" r="14"></circle>
            <circle id="Oval-Copy-2" fill={color} cx="66" cy="82" r="14"></circle>
            <circle id="Oval" fill={color} cx="34" cy="18" r="14"></circle>
            <circle id="Oval-Copy-3" fill={color} cx="66" cy="18" r="14"></circle>
        </g>
    </Svg>
}
